module.exports = __webpack_public_path__ + "img/login-bg-top.2717f86c.png";